import { Button, Spinner, Modal, TextInput, Textarea } from "flowbite-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import PurchaseInformation from "../purchase/PurchaseInformation";
import OrderItems from "../purchase/OrderItems";
import AddressInfo from "../../components/AdressInfo";
import toast from "react-hot-toast";
import { useUserServices } from "../../context/DealerProfile";
import AdditionalCharges from "./AdditionalCharges";

const fetcher = async (url) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Failed to fetch");
  }
  const data = await res.json();
  return data?.data;
};

const OrderDetail = ({ type }) => {
  const navigate = useNavigate();
  const { orderId } = useParams();

  // console.log({type, orderId});

  const isReturn = type === "return";
  const {
    data: orderDetails,
    error,
    isLoading,
  } = useSWR(
    `/server/dealer_backend/${isReturn ? "return" : "order"}/${orderId}`,
    fetcher
  );

  // console.log("data -> : ", orderDetails)
  const {
    dealerDetail: { dealerDiscountPercentage, parentAccount },
    priceItem,
  } = useUserServices();

  // console.log("dealer data ---> :", parentAccount.Tax_Rule);

  const [showModal, setShowModal] = useState(false);
  const [poNumber, setPoNumber] = useState("");
  const [remarks, setRemarks] = useState("");
  // console.log(remarks);
  // console.log(orderDetails?.Remark)

  const isEditable = ![
    "Void",
    "Pending For Availability Check",
    "Pending for Approval",
    "Order : Invoiced",
    "Order : Packed",
    "Order : Shipped",
    "Approved",
    "Rejected",
    "Cancelled",
    "Payment Received",
  ].includes(orderDetails?.Stage);

  // console.log({ error });

  if (error) return navigate(`/order-history`, { replace: true });
  if (isLoading)
    return (
      <div className="flex h-screen w-full justify-center items-center">
        <Spinner
          color="failure"
          aria-label="Failure spinner example"
          size="lg"
        />
      </div>
    );

  if (!isLoading && !orderDetails && !error)
    return navigate(`/order-history`, { replace: true });

  const Billing_Information = {
    Street1: orderDetails.Billing_Street,
    City: orderDetails.Billing_City,
    State: orderDetails.Billing_State,
    PostalCode: orderDetails.Billing_Code,
    Country: orderDetails.Billing_Country,
  };

  const Shipping_Information = {
    Street1: orderDetails.Shipping_Street,
    City: orderDetails.Shipping_City,
    State: orderDetails.Shipping_State,
    PostalCode: orderDetails.Shipping_Code,
    Country: orderDetails.Shipping_Country,
  };

  const {
    Owner,
    Dealer_Name,
    Orders_Items,
    Orders_Item,
    Stage,
    Remark,
    MOQ_Remarks,
    Grand_Total,
    Delivery_Date,
    Created_Time,
    ...others
  } = orderDetails;

  console.log("Order Deatails : ", orderDetails)

  const CP_Purchase_Information = {
    Dealer_Name: Dealer_Name?.name,
    Delivery_Date,
    CP_Purchase_Owner: Owner.name,
    Date: orderDetails.Date,
    Stage,
    Contact: orderDetails?.Contact?.id,
  };

  const formData = {
    CP_Purchase_Information,
    Owner,
    Dealer_Name,
    Billing_Information,
    Shipping_Information,
    Orders_Items: isReturn ? Orders_Item : Orders_Items,
    Stage,
    Grand_Total,
    Delivery_Date,
    Created_Time,
    ...others,
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    // console.log("vishalk");
    let loadingToast;
    try {
      e?.preventDefault(); // Prevent the default form submission behavior
      console.log("----------");

      // checking if po Number is availble or not
      if (!poNumber) {
        return toast.error("Please enter the PO Number.");
      }

      loadingToast = toast.loading("Placing Your Order ...");
      // Payload to be sent to the backend API
      const payload = {
        id: orderId, // Replace with the ID from your state or logic
        poNumber: poNumber, // Replace with the PO number from your state
      };
      // console.log({ payload });
      // Send data to your custom backend API
      const response = await fetch("/server/dealer_backend/place-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      console.log({ data });

      // Handle the response from the backend
      if (response.ok) {
        console.log("Order placed successfully");
        toast.success("Order Placed Successfully!", {
          id: loadingToast,
        });
        // Optionally close the modal and reset the PO number
        setShowModal(false);
        setPoNumber("");
        navigate("/order-history");
      } else {
        console.error("Failed to place order", data);
        toast.error("Failed to place order.", {
          id: loadingToast,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to place order.", {
        id: loadingToast,
      });
    }
  };

  // console.log({ Orders_Items });

  const handleEditOrder = async () => {
    const loadingToast = toast.loading("Preparing order for editing...");
    try {

    console.log({orderDetails});
      // Fetch detailed information for each order item
      const detailedOrderItems = await Promise.all(
        Orders_Items.map(async (item) => {
          try {
            const response = await fetch(
              `/server/dealer_backend/item/${item.Product_Name.id}`
            );
            const { status, data } = await response.json();
            if (status === "success" && data) {
              const updatedItemObj = {
                id: data.id,
                Product_Code: data.Product_Code,
                Product_Name: data.Product_Name,
                Quantity: item.Quantity,
                Unit_Price: data.Unit_Price,
                Distributors_Discount_Price: (data.Unit_Price - (data.Unit_Price * parentAccount?.Price_Tier2) / 100).toFixed(2),
                // Distributors_Discount_Price: data.Distributors_Discount_Price,
                Usage_Unit: data.Usage_Unit,
                // Usage_Unit: data.Usage_Unit,
                Description: data.Description,
                Minimum_Order_level: data.Minimum_Order_level,
                Record_Image: data.Record_Image,
                Product_Type: data.Product_Type,
                Book_Id: data.Book_Id,
                Sub_Category_B: data.Sub_Category_B,
                Weight: data.Weight,
                Karam_No: data.Karam_No,
                Dimensions: data.Dimensions,
                HS_Code: data.HS_Code,
              };

              let calculatedDiscountPrice = (
                data?.["Unit_Price"] -
                (data?.["Unit_Price"] * dealerDiscountPercentage) / 100
              ).toFixed(2);

              // Check if there is a matching priceItem
              const matchingPriceItem = priceItem?.find(
                (item) => item.item_id === data.Book_Id
              );

              updatedItemObj["Distributors_Discount_Price"] = matchingPriceItem
                ? matchingPriceItem.pricebook_rate
                : calculatedDiscountPrice;
              // console.log({ calculatedDiscountPrice, matchingPriceItem, priceItem, data });

              return updatedItemObj;
            } else {
              console.warn(
                `Failed to fetch details for item ID: ${item.Product_Name.id}`
              );
              return null;
            }
          } catch (error) {
            console.error(
              `Error fetching details for item ID: ${item.Product_Name.id}`,
              error
            );
            return null;
          }
        })
      );

      // Filter out items that failed to fetch
      const validOrderItems = detailedOrderItems.filter(
        (item) => item !== null
      );

      if (validOrderItems.length === 0) {
        throw new Error("No valid order items could be prepared.");
      }

      // Prepare the data for the new order form
      const editedOrderData = {
        Dealer_Name: Dealer_Name?.name,
        Delivery_Date,
        CP_Purchase_Owner: Owner.name,
        Date: orderDetails.Date,
        Stage: "Draft", // Reset stage to Draft for the new order
        Contact: orderDetails?.Contact?.id,
        Orders_Items: validOrderItems, // Use detailed order items here
        billingAddresses: orderDetails.Billing_Address_Link?.id,
        whichTypeShipping: orderDetails?.Request_Type == "Dropship" ? "end" : "in", // Set default or determine from original order
        inHouseShipping: orderDetails.Shipping_Address_Link?.id,
        // Tracking fields for edited orders
        isEdited: true,
        originalOrderId: orderDetails?.Parent_CP_PO ?? orderId,
        originalOrderName: orderDetails.Name,
        Request_Type: orderDetails?.Request_Type,
      };

      // console.log({ editedOrderData })
      // Store the prepared data
      localStorage.setItem("current_purchase", JSON.stringify(editedOrderData));
      toast.dismiss(loadingToast);
      toast.success("Order ready for editing");

      // Navigate to the new order form
      navigate("/purchase-order/new");
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("Failed to prepare order for editing");
      console.error("Edit order error:", error);
    }
  };

  //Update remarks

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleUpdateRemarks = async () => {
    try {
      const response = await fetch("/server/dealer_backend/update_remarks", {
        method: "PUT", // Use PUT method to update data
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: orderDetails?.id,
          Remark: remarks,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update remark");
      }

      const data = await response.json();
      console.log(data);
      toast.success("Remark updated successfully!");
    } catch (error) {
      toast.error(error);
    }
  };

  // console.log("formData", formData);

  const isAllowedStage = ![
    "Void",
    "Pending For Availability Check",
    "Pending for Approval - CEO",
    "Pending for Approval - Country Manager",
    "Pending for Approval",
  ].includes(formData?.Stage);

  return (
    <>
      <form className="space-y-8 max-w-5xl mx-auto p-4" onSubmit={handleSubmit}>
        <div className="card bg-base-100 shadow-xl py-6 px-10 relative ring-1 ring-neutral-200">
          <div className="card-header">
            <h2 className="card-title text-2xl font-bold text-center">
              {isReturn ? "Return Detail" : "Order Detail"}
            </h2>
          </div>
          <div className="card-body space-y-6 ">
            <PurchaseInformation
              formData={formData}
              onlyInfo={true}
              isReturn={isReturn}
            />
            <div className="flex flex-wrap gap-4">
              <AddressInfo
                addressType="Billing"
                addressData={Billing_Information}
              />
              <AddressInfo
                addressType="Shipping"
                addressData={Shipping_Information}
              />
            </div>
            {/* Description */}
            {!isReturn && (
              <div>
                <label className="label">Remarks</label>
                <Textarea
                  name="Remark"
                  id="Remark"
                  className={`w-1/2 sm:w-full  ${
                    isEditable ? "" : "cursor-not-allowed"
                  }`}
                  // onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                  value={remarks || orderDetails?.Remark}
                  onChange={handleRemarksChange}
                  readOnly={!isEditable}
                  rows={4}
                ></Textarea>
              </div>
            )}
            <OrderItems formData={formData} onlyInfo={true} />
            <div className="text-lg font-semibold text-right">
              Sub Total:
              <span className="ml-1">
                {`$ ${
                  formData?.Total_Custom_Discount_1 > 0 && isAllowedStage
                    ? formData.Grand_Total
                    : formData.Total_Distributor_Price ??
                      formData.Grand_Total ??
                        0
                }`}
              </span>
            </div>
            {orderDetails?.Additional_Charges?.length > 0 && (
              <AdditionalCharges
                Additional={orderDetails?.Additional_Charges}
                formData={formData}
              />
            )}
          </div>
        </div>

        <div className="flex justify-between items-center mt-6">
          <div className="text-lg font-semibold">
            Grand Total:
            <span className="ml-1">
              {orderDetails?.Additional_Charges?.length > 0
                ? `$ ${
                    formData?.Total_Custom_Discount_1 > 0 && isAllowedStage
                      ? formData.Grand_Total + formData?.Aggregate_Field_1
                      : formData.Total_Distributor_Price + formData?.Aggregate_Field_1
                  }`
                : `$ ${
                    formData?.Total_Custom_Discount_1 > 0 && isAllowedStage
                      ? formData.Grand_Total
                      : formData.Total_Distributor_Price ??
                        formData.Grand_Total ??
                        0
                  }`}
            </span>
            {parentAccount.Tax_Rule === "Standard-Rated Supplies" && (
              <span className="block text-red-600 font-bold mt-1">
                ADDITIONAL TAX APPLICABLE
              </span>
            )}
          </div>
          {/*  */}
          <div className="flex items-center gap-5">
            <Button
              type="button"
              onClick={() => window.history.back()}
              className="bg-gray-800 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg"
            >
              Back
            </Button>
            {isEditable ? (
              <Button
                onClick={handleUpdateRemarks}
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Update Remarks
              </Button>
            ) : (
              ""
            )}
          </div>

          {/* Place Order Button */}
          {Stage === "Confirm" && (
            <div className="flex gap-4">
              <Button
                onClick={handleEditOrder}
                className="bg-gray-800 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Edit Order
              </Button>
              <Button
                disabled={formData.Orders_Items.length === 0}
                onClick={() => setShowModal(true)}
                className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg"
              >
                Place Order
              </Button>
            </div>
          )}
        </div>
      </form>

      {/* Modal for PO Number */}
      {/* Modal for PO Number */}
      <Modal show={showModal} onClose={() => setShowModal(false)}>
        <Modal.Header>
          <h2 className="text-lg font-bold">Enter PO Number</h2>
        </Modal.Header>
        <Modal.Body>
          <TextInput
            placeholder="PO Number"
            value={poNumber}
            onChange={(e) => setPoNumber(e.target.value)}
            required
          />
        </Modal.Body>
        <Modal.Footer>
          {/* Confirm Order Button */}
          <Button
            onClick={handleSubmit} // Only call handleSubmit when confirming
            className="bg-blue-500 hover:bg-blue-700 text-white"
          >
            Place Order
          </Button>

          {/* Cancel Button */}
          <Button
            onClick={() => setShowModal(false)} // Only close the modal
            className="bg-gray-300 hover:bg-gray-400"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrderDetail;
